import {
  MEDIA_HM_PATH,
  OrderFront,
  OrderStatus,
  ProductFront,
  UpdateOrderRequest,
} from "@project/shared-types";
import { useMemo, useState } from "react";
import EditSvg from "../../../../assets/taiga-uikit/icons/arrow-right-1.svg?react";
import { Button } from "../../../../components/button/button";
import { Container, _flexDirection, _gap, _justifyContent } from "../../../../components/Container/Container";
import { EditableText } from "../../../../components/EditableText/EditableText";
import { FeedBack } from "../../../../components/FeedBack/FeedBack";
import { Input } from "../../../../components/inputs/Input";
import { InputCounter } from "../../../../components/inputs/InputCounter";
import { Link } from "../../../../components/link/link";
import { Push } from "../../../../components/Push/Push";
import { Copy } from "../../../../components/texts/Copy/Copy";
import { Label } from "../../../../components/texts/label";
import { Text } from "../../../../components/texts/text";
import { _colorText, _size, _sizeText, _status, _style, _typeLabel } from "../../../../core/core";
import { get_status_name_order, get_status_order } from "../../../../hooks/tools";
import { useSupport } from "../../../support/ui/SupportProvider";
import {
  RePayedOrderAPI,
  UpdateOrderAPI,
} from "../../model/order.api";
import { extractOrderId } from "../../model/order.utils";
import "./OrderCardPreview.css";

interface OrderCardPreviewProps {
  order: OrderFront;
  is_order?: boolean;
  is_no_pay_jobs?: boolean;
  services: ProductFront[];
  onAddJob?: () => void;
  onPayJobs?: () => void;
  [key: string]: any; // Для поддержки дополнительных свойств
}

export const OrderCardPreview: React.FC<OrderCardPreviewProps> = ({
  order,
  services: products,
  is_order = false,
  onAddJob,
  is_no_pay_jobs = false,
  onPayJobs,
  ...props
}) => {
  const [title, setTitle] = useState<string>(order.client.name_order);
  const [urlValue, setUrlValue] = useState<string>(order.url);
  const [description, setDescription] = useState<string>(order.description);
  const [hour, setHour] = useState<number>(0);
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const { openSupport, selectOrder } = useSupport();
  const handleDoubleClick = () => {
    // Обработчик двойного клика
  };

  const feathChangeOrder = async () => {
    try {
      const requestData = {
        id: order.id,
        patch: {
          title: title,
          url: urlValue,
          order_id: order.id,
          description: description,
          hours: hour,
        },
      } as UpdateOrderRequest;
      const response = await UpdateOrderAPI(requestData);
      if (!response) {
        setIsEdit(false);
      }
      if (typeof window !== "undefined") {
        window.location.reload();
      }
    } catch (e) {
      console.error("Ошибка при обновлении названия заказа:", e);
    }
  };

  const handleBlur = () => {
    if (title.trim().length === 0) {
      setTitle(order.client.name_order);
    } else {
      feathChangeOrder();
    }
  };

  const repayedOrder = async () => {
    const response = await RePayedOrderAPI({
      order_id: order.id,
    });
    if (!response) return;
    const orderId = response.order_id ?? extractOrderId(response.url);
    window.open(response.url, "_blank", "noopener");
    if (orderId) {
      document.location.href = `/account/order/${orderId}/`;
    } else {
      document.location.href = response.url;
    }
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    if (value && value.length < 30) {
      setTitle(value);
    }
  };

  const handleClick = (e: React.MouseEvent<HTMLElement>) => {
    const target = e.target as HTMLElement;

    if (
      !target.classList.contains("order-header-info") &&
      !is_order &&
      target.tagName !== "BUTTON"
    ) {
      document.location.href = `/account/order/${order.id}/`;
    }
  };
  const handlePay = (e: React.MouseEvent<HTMLElement>) => {
    e.preventDefault();
    e.stopPropagation();
    repayedOrder();
  };
  const serviceMemo = useMemo(() => {
    if (!products || products.length === 0) return undefined;
    return products.find((product) => product.place.id === order.place_id);
  }, [products, order.place_id]);
  if (!order) return <>Ошибка с заказом</>;
  return (
    <div onClick={handleClick} className={"order-card-preview"} {...props}>
      <div className="order-card-body">
        <div className="order-card-p-title">
          <div className="order-card-p-title-g">
            <div className="order-card-p-title-l">
              {serviceMemo && serviceMemo.service_url && (
                <img src={`${MEDIA_HM_PATH}${serviceMemo.icon}`}></img>
              )}
              <div className="order-header-info">
                <EditableText
                  onClick={handleDoubleClick}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  maxLength={60}
                  value={title}
                  size={_sizeText.l}
                  color={_colorText.black}
                />
                <Copy value={order.id.toString()}>
                  <Text size={_sizeText.l} color={_colorText.neutral}>
                    №{order.number}
                  </Text>
                </Copy>
              </div>
            </div>
            <div className="order-card-p-title-r">
              <Label
                size={_size.XS}
                type={_typeLabel.primary}
                status={_status.neutral}
              >
                Выполнено {order.job_complite}/{order.job_count}
              </Label>
              <Label
                size={_size.XS}
                type={_typeLabel.primary}
                status={get_status_order(order.status)}
              >
                {get_status_name_order(order.status)}
              </Label>
            </div>
          </div>
          <Link
            size={_size.XS}
            style={_style.outline}
            link={"/account/order/" + order.id}
            icon_left={<EditSvg />}
          ></Link>
        </div>
        <div className="order-card-info">
          {!isEdit ? (
            <div className="order-card-info-left">
              <div className="order-card-info-left-row">
                <Text size={_sizeText.m} color={_colorText.neutral}>
                  Ссылка:
                </Text>
                <Link style={_style.link} link={order.url} size={_size.XS}>
                  {order.client.name_order.length > 10
                    ? order.client.name_order.substring(0, 10) + "..."
                    : order.client.name_order}
                </Link>
              </div>
              <div className="order-card-info-left-column">
                <Text size={_sizeText.m} color={_colorText.neutral}>
                  Описание:
                </Text>
                <Text size={_sizeText.m} color={_colorText.black}>
                  {order.description}
                </Text>
              </div>
              {order.status === OrderStatus.INIT && (
                <Push
                  id="pay_order"
                  text="Для сохранения заказа необходимо произвести оплату в течение 7 дней"
                  status="warning"
                ></Push>
              )}
            </div>
          ) : (
            <div className="order-card-info-left-column">
              {order.status === "modar" ? (
                <>
                  <Input
                    labelOutside="Ссылка:"
                    placeholder="Ссылка на вашу карточку"
                    value={urlValue}
                    setValue={setUrlValue}
                    description="Ссылка должна вести на вашу карточку, это нужно для проверки заданий"
                  ></Input>
                </>
              ) : (
                <>
                  <Input
                    labelOutside="Описание:"
                    placeholder="Описание для заданий..."
                    value={description}
                    setValue={setDescription}
                  ></Input>
                  <InputCounter
                    labelOutside="Интервла между заданиями в часах: (не обязательно)"
                    value={hour}
                    setValue={setHour}
                    description={
                      "Оставьте 0 часов, если не хотите менять дату у заданий"
                    }
                  ></InputCounter>
                </>
              )}
              <Button size={_size.S} onClick={() => feathChangeOrder()}>
                Сохранить
              </Button>
              <Button
                size={_size.S}
                style={_style.outline}
                onClick={() => setIsEdit(false)}
              >
                Отменить
              </Button>
            </div>
          )}
          {!isEdit && (
            <Container direction={_flexDirection.row} gap={_gap.s}>
              {order.status === "init" ? (
                <Button onClick={handlePay} size={_size.S}>
                  Оплатить
                </Button>
              ) : (
                <>
                  {is_no_pay_jobs ? (
                    <Button onClick={onPayJobs} size={_size.S}>
                      Оплатить задания
                    </Button>
                  ) : (
                    <Button onClick={onAddJob} size={_size.S}>
                      Добавить задания
                    </Button>
                  )}
                </>
              )}
            </Container>
          )}
        </div>
        <Container direction={_flexDirection.row} gap={_gap.s} justify={_justifyContent.flexStart}>
          {order.status === "modar" && !isEdit ? (
            <>
              <Push
                id="1255"
                status={"error"}
                title="Проблема с ссылкой"
                shadow={false}
                text="Пожалуйста укажите правильную ссылку на вашу карточку, чтобы мы могли эффективно выполнять заказ. Ссылка должна вести на вашу карточку."
              ></Push>
              <Button
                size={_size.S}
                style={_style.primary}
                onClick={() => setIsEdit(!isEdit)}
              >
                Исправить
              </Button>
            </>
          ) : (
            <>
              {is_order && !isEdit && ["work", "init"].includes(order.status) && (
                <Button
                  size={_size.S}
                  style={_style.primary}
                  onClick={() => setIsEdit(!isEdit)}
                >
                  Изменить
                </Button>
              )}
              <Button
                size={_size.S}
                style={_style.outline}
                onClick={() => {
                  selectOrder(order.id);
                  openSupport();
                }}
              >
                Помощь
              </Button>
            </>)}
        </Container>
      </div>
      {
        order.status === "close" ? (
          <FeedBack title="Оцените работу по заказу" id={order.id} is_order />
        ) : null
      }
    </div >
  );
};
